export default __webpack_public_path__ + "static/media/L4.9cafc12b.svg";